import { protectedContentAxios } from '@/lib/axiosInstance';
import {
  DeleteCommentRequest,
  DeleteCommentResponse,
  GetCommentsRequest,
  GetCommentsResponse,
  SendCommentRequest,
  SendCommentResponse,
  UpdateCommentRequest,
  UpdateCommentResponse,
} from '@/types/api/comments';

export const sendComment = async (
  payload: SendCommentRequest
): Promise<SendCommentResponse> => {
  const response = await protectedContentAxios.post<SendCommentResponse>(
    '/comments',
    payload
  );

  return response.data;
};

export const updateComment = async (
  payload: UpdateCommentRequest
): Promise<UpdateCommentResponse> => {
  const { commentId, content } = payload;
  const response = await protectedContentAxios.put<UpdateCommentResponse>(
    `/comments/${commentId}`,
    {
      content,
    }
  );

  return response.data;
};

export const deleteComment = async (
  payload: DeleteCommentRequest
): Promise<DeleteCommentResponse> => {
  const { commentId } = payload;
  const response = await protectedContentAxios.delete<DeleteCommentResponse>(
    `/comments/${commentId}`
  );

  return response.data;
};

export const getComments = async (
  payload: GetCommentsRequest
): Promise<GetCommentsResponse> => {
  const {
    storyId,
    limit,
    page,
    orderBy,
    parentCommentId,
    userId,
    focusedCommentId,
  } = payload;

  const queryParams = new URLSearchParams({
    storyId,
    limit: limit.toString(),
    page: page.toString(),
    orderBy: orderBy || 'createdDate:desc',
    parentCommentId: parentCommentId || '',
    userId: userId || '',
    focusedCommentId: focusedCommentId || '',
  });

  // Remove empty query parameters
  for (const [key, value] of queryParams.entries()) {
    if (value === '') {
      queryParams.delete(key);
    }
  }

  const response = await protectedContentAxios.get<GetCommentsResponse>(
    `/comments?${queryParams.toString()}`
  );

  return response.data;
};
